import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { CONFIG } from 'variables/config';
import { MdOutlineVpnKey } from 'react-icons/md';
import { timeAgo } from 'services/integrations';

/**
 * Mon compte → Clé API, for sellers: the key is no longer managed here. Its state is shown, and one
 * button leads to where it's created and managed — Intégrations → Envoi par API, next to the
 * step-by-step guide that uses it (seller/apiDocs).
 */
const SellerApiKeyRedirect = () => {
    const navigate = useNavigate();
    const [apiKey, setApiKey] = useState<{ prefix: string; status: string; lastUsedAt: string | null } | null | undefined>(undefined);

    useEffect(() => {
        axios
            .get(`${CONFIG.apiUrl}/account/api-key`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
            .then((res) => setApiKey(res.data?.apiKey ?? null))
            .catch(() => setApiKey(null));
    }, []);

    return (
        <div className="flex flex-col gap-5 rounded-[18px] border border-[#EDE7DE] bg-white p-6 font-hanken text-[#1A1613]">
            <div className="flex items-start gap-3.5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-[12px] bg-[#E6F3FF] text-[#1D6FD8]">
                    <MdOutlineVpnKey className="h-6 w-6" />
                </span>
                <div>
                    <h3 className="font-newsreader text-[24px] font-medium leading-tight text-[#14110E]">Clé API</h3>
                    <p className="mt-1 max-w-[560px] text-[14px] leading-relaxed text-[#6B6357]">
                        Votre clé API se crée et se gère dans <strong className="text-[#3B352C]">Intégrations → Envoi par API</strong>, à côté du
                        guide pas à pas qui explique comment l'utiliser. La même clé sert aussi à vos sites créés avec l'IA.
                    </p>
                </div>
            </div>

            <div className="flex flex-wrap items-center gap-2.5 rounded-[12px] border border-[#EDE7DE] bg-[#FAF8F4] px-4 py-3 text-[13.5px]">
                {apiKey === undefined ? (
                    <span className="text-[#8A8172]">Chargement…</span>
                ) : apiKey ? (
                    <>
                        <span className="h-2 w-2 rounded-full bg-[#1E9E52]" />
                        <span>
                            <strong>Clé active</strong> · <span className="font-jbmono text-[12.5px]">{apiKey.prefix}…</span> · dernière utilisation{' '}
                            {apiKey.lastUsedAt ? timeAgo(apiKey.lastUsedAt) : 'jamais'}
                        </span>
                    </>
                ) : (
                    <>
                        <span className="h-2 w-2 rounded-full bg-[#C9BFAE]" />
                        <span className="text-[#6B6357]">Vous n'avez pas encore de clé API.</span>
                    </>
                )}
            </div>

            <div className="flex flex-wrap items-center gap-3">
                <button
                    onClick={() => navigate('/seller-api-docs')}
                    className="rounded-[11px] bg-[#241C5C] px-4 py-2.5 text-[14px] font-semibold text-white transition-colors hover:bg-[#332a75]"
                >
                    {apiKey ? 'Gérer ma clé API →' : 'Créer ma clé API →'}
                </button>
                <button onClick={() => navigate('/integrations')} className="text-[13.5px] font-semibold text-[#241C5C] hover:underline">
                    Voir mes intégrations
                </button>
            </div>
        </div>
    );
};

export default SellerApiKeyRedirect;
